(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section_lp_3"] && !Shopify.designMode) return;
  try {
    
(function() {
  function ensureSwiper(cb) {
    if (window.Swiper) return cb();

    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    document.head.appendChild(css);

    var js = document.createElement('script');
    js.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    js.onload = cb;
    document.head.appendChild(js);
  }

  ensureSwiper(function() {
    document.querySelectorAll('.landing-annabelle-section-4-slider.swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        autoHeight: true,
        navigation: {
          nextEl: el.querySelector('.js-landing-comments-slider-navigation-next'),
          prevEl: el.querySelector('.js-landing-comments-slider-navigation-prev')
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_lp_7"] && !Shopify.designMode) return;
  try {
    
(function() {
  function ensureSwiper(cb) {
    if (window.Swiper) return cb();
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    document.head.appendChild(css);
    var js = document.createElement('script');
    js.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    js.onload = cb;
    document.head.appendChild(js);
  }

  ensureSwiper(function() {
    document.querySelectorAll('.landing-annabelle-section-8-slider.swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
          0:   { slidesPerView: 1, spaceBetween: 10 },
          480: { slidesPerView: 1.3, spaceBetween: 12 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          992: { slidesPerView: 3, spaceBetween: 24 },
          1200:{ slidesPerView: 4, spaceBetween: 30 }
        },
        navigation: {
          nextEl: el.querySelector('.js-landing-products-slider-navigation-next'),
          prevEl: el.querySelector('.js-landing-products-slider-navigation-prev')
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
